import styled from "styled-components";

export const StyledWrapper = styled.div`
  margin-top: 36px;

  .page-heading {
    margin-bottom: 16px;
    height: 40px;
    float: left;

    h1 {
      color: ${({ theme }) => theme.colors.neutralsText};
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    }
  }
`;
